import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  '@global': {
    '#indemn-webchat .rw-conversation-container .rw-message .rw-response .rw-markdown a[href]': {
      // Staff's global display: contents removes the box needed for link decoration and focus.
      display: 'inline',
      textDecoration: 'underline solid !important',
      textUnderlineOffset: '0.15em',
      cursor: 'pointer',
      '&:focus-visible': {
        outline: '2px solid currentColor',
        outlineOffset: 2
      }
    }
  },
  // Indemn.chat.hide() closes the conversation window but leaves its launcher in this anchor.
  hidden: { display: 'none !important' }
}));
